import { IApplicantOfferSummaryTableRow, IApplicationSummaryTableRow } from 'types';
import { TableRow } from '../types';

export const serialiseDashboardEntryToDashboardRow = (
  entry: IApplicationSummaryTableRow | IApplicantOfferSummaryTableRow,
  idx: number,
): TableRow => {
  const row = {
    ...entry,
    idx,
    offerId: 'offerId' in entry ? entry.offerId : entry.applicationId,
    name: 'offerId' in entry ? `${entry.applicationId}-${entry.offerId}` : `${entry.applicationId}-${entry.userId}`,
  };
  return row;
};

export const serialiseDashboardEntiresToDashboardRows = (
  entries: Array<IApplicationSummaryTableRow | IApplicantOfferSummaryTableRow>,
): TableRow[] => entries?.map(serialiseDashboardEntryToDashboardRow) ?? [];
